import { createFileRoute, Link } from '@tanstack/react-router';
import { use } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { AbilityContext } from '../../../ability';
import { BatchHistory } from '../../../components/cards/BatchHistory';

const searchSchema = z.object({
  page: z.number().int().min(1).optional().default(1),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});

export const Route = createFileRoute('/_auth/history/')({
  validateSearch: searchSchema,
  component: HistoryPage,
});

function HistoryPage() {
  const { t } = useTranslation();
  const ability = use(AbilityContext);
  const isAdmin = ability.can('read', 'Audit');

  return (
    <div>
      <Link to="/" className="btn-link mb-6">
        {t('nav.backToHub')}
      </Link>
      <header className="section-head">
        <div>
          <p className="label dash">{t('history.subheader')}</p>
          <h1 className="display mt-2 text-3xl md:text-5xl">
            {t('history.header')}
          </h1>
        </div>
        <p className="label">
          {isAdmin ? t('history.meta.all') : t('history.meta.self')}
        </p>
      </header>

      <section className="epi-card">
        <div className="epi-card-head">
          <span className="num">{t('history.cardHead.num')}</span>
          <span className="title">{t('history.cardHead.title')}</span>
          <span className="meta">{t('history.cardHead.meta')}</span>
        </div>
        <BatchHistory isAdmin={isAdmin} />
      </section>
    </div>
  );
}
